export const DS_TITLE_FIELD_CLASSES = {
  Root: "ds-title-field",
  Editing: "ds-title-field--editing",
  Empty: "ds-title-field--empty",
  Interactive: "ds-title-field__interactive",
  DisplayControl: "ds-title-field__display-control",
  DisplayContent: "ds-title-field__display-content",
  DisplayText: "ds-title-field__display-text",
  Placeholder: "ds-title-field__display-content--placeholder",
  EmptyContent: "ds-title-field__display-content--empty",
  EmptyHint: "ds-title-field__empty-hint",
  EmptyHoverHint: "ds-title-field__empty-hint--hover",
  EmptyFocusHint: "ds-title-field__empty-hint--focus",
  Editor: "ds-title-field__editor",
  Input: "ds-title-field__input",
  Actions: "ds-title-field__actions",
  Error: "ds-title-field__error",
  ErrorMessages: "ds-title-field__error-messages",
} as const;
